"use client";
import React from "react";
import DiscountValueSection from "@/components/coupon/amount-off-products/DiscountValueSection";
import ActiveDatesSection from "@/components/coupon/activeDatesSection";
import MinimumPurchaseRequirements from "@/components/coupon/minimumPurchaseRequirements";
import DiscountMethodSection from "@/components/coupon/discountMethodSection";
import BreadCrumbs from "@/components/coupon/breadCrumbs";
import SaveAmountOffProducts from "@/components/coupon/amount-off-products/saveCoupon";

const AmountOffProductsPage = () => {
  return (
    <div className="coupon-page space-y-6">
      <BreadCrumbs page="Amount Off Products" />
      <DiscountMethodSection currentPage="amountOffProducts" />
      <DiscountValueSection />
      <div className="grid w-full grid-cols-[repeat(auto-fit,minmax(min(250px,100%),1fr))] gap-5">
        <MinimumPurchaseRequirements currentPage="amountOffProducts" />
        <ActiveDatesSection currentPage="amountOffProducts" />
      </div>
      <SaveAmountOffProducts currentPage="amountOffProducts" />
    </div>
  );
};

export default AmountOffProductsPage;
